module.exports = __webpack_public_path__ + "static/media/calculus-i-not-enrolled.38fb79e9.svg";